const WebinarVideoProvider = `
  fragment WebinarVideoProvider on WebinarVideoProvider {
    date
    providerType
    url
  }
`
export default WebinarVideoProvider
